import { Injectable } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { LogService } from "./log.service";
import { ShareService } from "./share.service";
import { LogisticsShareable, makeDefaultShareLogisticsExcludedFields } from "globals/store/share.data";
import { EventService } from "./event.service";
import { transformObservableToSinglePromise } from "../helpers/angular-helpers";
import { FilterGroup } from "globals/store/filters.data";
import { deleteDoc, doc, Firestore, setDoc } from "@angular/fire/firestore";
import { filtersFeature } from "../store/filters.era";


@Injectable({ providedIn: 'root' })
export class LogisticsShareService {
  readonly _file = 'share.logistics.service.ts'

  constructor(
    private log: LogService,
    public store: Store,
    private shareService: ShareService,
    private eventService: EventService,
    private db: Firestore,
  ) { }

  async createLogisticsShareable(title: string = '', description: string = '') {

    const code = await this.shareService.generateShareCode()
    const logisticsShareable: LogisticsShareable = {
      eventId: this.eventService.eventId,
      title: title || '',
      description: description || '',
      excludedFieldIds: makeDefaultShareLogisticsExcludedFields(),
      filters: { count: 0 },
      type: 'logistics',
      code,
      status: 'never shared'
    }
    console.log(logisticsShareable)

    await setDoc(doc(this.db, '/shareables/'+code), logisticsShareable)
  }

  async deleteLogisticsShareables(codes: string[]) {
    await Promise.all(codes.map(c => deleteDoc(doc(this.db, '/shareables/' + c))))
  }

  async duplicateLogisticsShareable(shareable: LogisticsShareable, title: string = '') {
    const code = await this.shareService.generateShareCode()
    const duplicatedShareable: LogisticsShareable = {
      ...shareable,
      title,
      code
    }
    await setDoc(doc(this.db, '/shareables/'+code), duplicatedShareable)
  }

  async updateLogisticsShareable(code: string, update: Partial<LogisticsShareable>) {
    console.log(update)
    await setDoc(doc(this.db, '/shareables/'+code), update, { merge: true })
  }

  async updateOpenFilters(code: string) {
    const filters = await transformObservableToSinglePromise<FilterGroup>(this.store.pipe(select(filtersFeature.selectProgramLogistics)))
    delete filters.search
    await this.updateLogisticsShareable(code, { filters })
  }

}